import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getRequestData } from "../../helpers/helpers";
import { getLogDetails, getLogReport } from "../../service/client";
import { getDocumentImage } from "../../service/admin";
import { t } from "../../locale";

export default function VideoIdentificationPage() {

  const { company_id, request_id } = useParams()

  const [client, setClient] = useState<any>(null)
  const [logData, setLogData] = useState<any>(null)
  const [report, setReport] = useState<any>(null)

  useEffect(() => {
    if (company_id && request_id) {
      fetchClientData(company_id, request_id)
      fetchLogData(company_id, request_id)
      fetchReport(company_id, request_id)
      fetchDocumentImage(request_id)
      fetchDocumentBackImage(request_id)
      fetchDocumentFace(request_id)
    }
  }, [company_id, request_id]);

  const fetchClientData = async (company_id?: string, request_id?: string) => {
    if (!company_id || !request_id) return;
    try {
      const client_data = await getRequestData(company_id, request_id)
      setClient(client_data)
    } catch (err) {
      console.error("Error fetchClientData:", err)
    }
  }

  const fetchLogData = async (company_id?: string, request_id?: string) => {
    if (!company_id || !request_id) return;
    try {
      const log_data = await getLogDetails(company_id, request_id)

      if (log_data.message?.variant === 'success') {
        setLogData(log_data.message.content)
      }
    } catch (err) {
      console.error("Error fetchLogData:", err)
    }
  }

  const fetchReport = async (company_id?: string, request_id?: string) => {
    if (!company_id || !request_id) return;
    try {
      const rep = await getLogReport(company_id, request_id)
      if (rep.message?.variant === 'success') {
        console.log('rr: ' + rep.message.content.document)
        setReport(rep.message.content)
      }
    } catch (err) {
      console.error("Error fetchReport:", err)
    }
  }

  const fetchDocumentImage = async (request_id?: string) => {
    if (!request_id) return

    const res = await getDocumentImage(request_id, 'document')
    if (res.message?.variant === 'success') {
      if (res.message?.variant === 'success') {

        const img = document.getElementById('documentFront') as HTMLImageElement
        if (img)
          img.src = "data:image/png;base64," + res.message.content
      }
    }
  }

  const fetchDocumentBackImage = async (request_id?: string) => {
    if (!request_id) return

    const res = await getDocumentImage(request_id, 'document_back')
    if (res.message?.variant === 'success') {
      if (res.message?.variant === 'success') {

        const img = document.getElementById('documentBack') as HTMLImageElement
        if (img)
          img.src = "data:image/png;base64," + res.message.content
      }
    }
  }

  const fetchDocumentFace = async (request_id?: string) => {
    if (!request_id) return

    const res = await getDocumentImage(request_id, 'self')
    if (res.message?.variant === 'success') {
      if (res.message?.variant === 'success') {

        const img = document.getElementById('face') as HTMLImageElement
        if (img)
          img.src = "data:image/png;base64," + res.message.content
      }
    }
  }

  const [view, setView] = useState<"passed" | "failed">("failed");

  function getStatusBg(status: string) {
    switch ((status || '')) {
      case 'SUBMITTED':
        return 'bg-success'
      case 'INITIATED':
        return 'bg-primary'
      case 'NEW':
        return 'bg-primary'
      case 'PENDING_PAYMENT':
        return 'bg-warning'
      default:
        return 'bg-primary'; // podrazumevano
    }
  }

  return (
    <div className="container my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">{t('videoIdentification')}</h2>

      </div>

      {/* Status + osnovni podaci */}
      <div className="card mb-4 shadow-sm">
        {client && (<div className="card-body">
          <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
            <span
              className={`badge text-uppercase ${getStatusBg(client.status)}`}
              style={{ letterSpacing: '.02em' }}
            >
              {client.status}
            </span>

            <span className="text-muted">Start:</span>
            <strong className="me-3">{client.createdAt}</strong>
          </div>

          <div className="row g-3">
            <div className="col-md-6">
              <h5 className="mb-3">{t('requestData')}</h5>
              <table className="table table-sm mb-0">
                <tbody>
                  <tr>
                    <th className="w-25">{t('name')}</th>
                    <td>{client.firstName + ' ' + client.lastName}</td>
                  </tr>
                  <tr>
                    <th>{t('dateOfBirth')}</th>
                    <td>{client.dateOfBirth}</td>
                  </tr>
                  <tr>
                    <th>{t('nationality')}</th>
                    <td>{client.nationality}</td>
                  </tr>
                  <tr>
                    <th>{t('id')}</th>
                    <td>{client.passport == true ? 'passport' : 'id'} ({client.idNumber})</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className='col-md-6'>
              <h5 className='mb-3'>{t('checks')}</h5>

              <div>
                <ul className='nav nav-tabs' id='myTab' role='tablist'>
                  <li className='nav-item' role='presentation'>
                    <button
                      className='nav-link active'
                      id='doc-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#doc'
                      type='button'
                      role='tab'
                    >
                      Document Log
                    </button>
                  </li>
                  <li className='nav-item' role='presentation'>
                    <button
                      className='nav-link'
                      id='mrz-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#mrz'
                      type='button'
                      role='tab'
                    >
                      MRZ Check
                    </button>
                  </li>
                  <li className='nav-item' role='presentation'>
                    <button
                      className='nav-link'
                      id='liveness-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#liveness'
                      type='button'
                      role='tab'
                    >
                      Liveness
                    </button>
                  </li>
                  <li className='nav-item' role='presentation'>
                    <button
                      className='nav-link'
                      id='similarity-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#similarity'
                      type='button'
                      role='tab'
                    >
                      Similarity
                    </button>
                  </li>
                  <li className='nav-item' role='presentation'>
                    <button
                      className='nav-link'
                      id='fints-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#fints'
                      type='button'
                      role='tab'
                    >
                      FinTS
                    </button>
                  </li>
                </ul>

                {/* Tabs sadržaj */}
                <div className='tab-content border p-3' id='myTabContent'>
                  <div
                    className='tab-pane fade show active'
                    id='doc'
                    role='tabpanel'
                    aria-labelledby='doc-tab'
                  >
                    {Array.isArray(logData?.documentLog) && logData.documentLog.length > 0 ? (
                      logData.documentLog.map((entry: any, index: number) => (
                        <div key={index} className="mb-4 border-bottom pb-3">
                          <h6 className="fw-bold">Document Log #{index + 1}</h6>
                          <table className="table table-sm table-bordered mb-2">
                            <tbody>
                              <tr>
                                <th style={{width:'40%'}}>Valid</th>
                                <td><span className={entry.valid ? 'text-success fw-bold' : 'text-danger fw-bold'}>{String(entry.valid)}</span></td>
                              </tr>
                              {entry.error && <tr><th>Error</th><td className="text-danger">{entry.error}</td></tr>}
                              {entry.filter && <tr><th>Filter</th><td>{entry.filter}</td></tr>}
                              {Array.isArray(entry.invalid) && entry.invalid.length > 0 && (
                                <tr><th>Invalid Fields</th><td className="text-danger">{entry.invalid.join(', ')}</td></tr>
                              )}
                            </tbody>
                          </table>
                          {entry.extracted && (
                            <div className="mb-2">
                              <strong>Extracted Data:</strong>
                              <table className="table table-sm table-bordered mt-1">
                                <tbody>
                                  {Object.entries(entry.extracted).map(([k, v]: [string, any]) => (
                                    <tr key={k}><th style={{width:'40%'}}>{k}</th><td>{String(v ?? '—')}</td></tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                          {Array.isArray(entry.fields) && entry.fields.length > 0 && (
                            <div className="mb-2">
                              <strong>Field Validation:</strong>
                              <table className="table table-sm table-bordered mt-1">
                                <thead><tr><th>Field</th><th>Valid</th></tr></thead>
                                <tbody>
                                  {entry.fields.map((f: any, i: number) => (
                                    <tr key={i}>
                                      <td>{f.field}</td>
                                      <td><span className={f.valid ? 'text-success' : 'text-danger'}>{String(f.valid)}</span></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No document log available.</p>
                    )}
                  </div>

                  <div
                    className="tab-pane fade"
                    id="mrz"
                    role="tabpanel"
                    aria-labelledby="mrz-tab"
                  >
                    {Array.isArray(logData?.mrzCheck) && logData.mrzCheck.length > 0 ? (
                      logData.mrzCheck.map((entry: any, index: number) => (
                        <div key={index} className="mb-4 border-bottom pb-3">
                          <h6 className="fw-bold">MRZ Check #{index + 1}</h6>
                          <table className="table table-sm table-bordered mb-2">
                            <tbody>
                              <tr>
                                <th style={{width:'40%'}}>Valid</th>
                                <td><span className={entry.valid ? 'text-success fw-bold' : 'text-danger fw-bold'}>{String(entry.valid)}</span></td>
                              </tr>
                              {entry.mrzType && <tr><th>MRZ Type</th><td>{entry.mrzType}</td></tr>}
                              {entry.attempt && <tr><th>Attempt</th><td>{entry.attempt}</td></tr>}
                              {entry.fixApplied !== undefined && <tr><th>Fix Applied</th><td>{String(entry.fixApplied)}</td></tr>}
                              {entry.error && <tr><th>Error</th><td className="text-danger">{entry.error}</td></tr>}
                              {entry.detectedLength !== undefined && <tr><th>Detected Length</th><td>{entry.detectedLength}</td></tr>}
                              {entry.expectedLength !== undefined && <tr><th>Expected Length</th><td>{entry.expectedLength}</td></tr>}
                              {entry.mrz_value && <tr><th>MRZ Raw</th><td><code style={{wordBreak:'break-all'}}>{entry.mrz_value}</code></td></tr>}
                            </tbody>
                          </table>
                          {Array.isArray(entry.mrz) && entry.mrz.length > 0 && (
                            <div className="mb-2">
                              <strong>MRZ Lines:</strong>
                              {entry.mrz.map((line: string, i: number) => (
                                <div key={i}><code style={{wordBreak:'break-all'}}>{line}</code></div>
                              ))}
                            </div>
                          )}
                          {Array.isArray(entry.paragraphs) && entry.paragraphs.length > 0 && (
                            <details>
                              <summary className="text-muted small">Raw paragraphs ({entry.paragraphs.length})</summary>
                              <pre className="small mt-1">{JSON.stringify(entry.paragraphs, null, 2)}</pre>
                            </details>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No MRZ data available.</p>
                    )}
                  </div>

                  <div
                    className="tab-pane fade"
                    id="liveness"
                    role="tabpanel"
                    aria-labelledby="liveness-tab"
                  >
                    {Array.isArray(logData?.livenessCheck) && logData.livenessCheck.length > 0 ? (
                      logData.livenessCheck.map((lc: any, index: number) => (
                        <div key={index} className="mb-4 border-bottom pb-3">
                          <h6 className="fw-bold">Liveness Check #{index + 1}</h6>
                          <table className="table table-sm table-bordered mb-3">
                            <tbody>
                              <tr>
                                <th style={{width:'40%'}}>Passed</th>
                                <td><span className={lc.passed ? 'text-success fw-bold' : 'text-danger fw-bold'}>{String(lc.passed)}</span></td>
                              </tr>
                              {lc.reason && <tr><th>Reason</th><td className="text-danger">{lc.reason}</td></tr>}
                              {lc.failedPose && <tr><th>Failed Pose</th><td className="text-danger">{lc.failedPose}</td></tr>}
                              {lc.yawDiff !== undefined && <tr><th>Yaw Diff</th><td>{lc.yawDiff?.toFixed(2)} (threshold: {lc.yawThreshold})</td></tr>}
                              {lc.pitchDiff !== undefined && <tr><th>Pitch Diff</th><td>{lc.pitchDiff?.toFixed(2)} (threshold: {lc.pitchThreshold})</td></tr>}
                              {lc.received && (
                                <tr><th>Images Received</th><td>
                                  forward: {String(lc.received.forward)}, left: {String(lc.received.left)}, down: {String(lc.received.down)}
                                </td></tr>
                              )}
                              {lc.detected && (
                                <tr><th>Face Detected</th><td>
                                  forward: {String(lc.detected.forward)}, left: {String(lc.detected.left)}, down: {String(lc.detected.down)}
                                </td></tr>
                              )}
                            </tbody>
                          </table>
                          {lc.poses && (
                            <div className="mb-2">
                              <strong>Poses:</strong>
                              <p className="text-muted small mb-1 mt-1">
                                Liveness passes if <strong>|forward yaw − left yaw| &gt; 8°</strong> (head turned left) <em>or</em> <strong>|forward pitch − down pitch| &gt; 10°</strong> (head looked down).
                              </p>
                              <table className="table table-sm table-bordered mt-1">
                                <thead><tr><th>Direction</th><th>Yaw</th><th>Pitch</th><th>Roll</th></tr></thead>
                                <tbody>
                                  {['forward', 'left', 'down'].map((dir) => lc.poses[dir] && (
                                    <tr key={dir}>
                                      <td>{dir}</td>
                                      <td>{lc.poses[dir].yaw?.toFixed(2)}</td>
                                      <td>{lc.poses[dir].pitch?.toFixed(2)}</td>
                                      <td>{lc.poses[dir].roll?.toFixed(2)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                          {lc.rawDetections && (
                            <details>
                              <summary className="text-muted small">Raw detections</summary>
                              <pre className="small mt-1">{JSON.stringify(lc.rawDetections, null, 2)}</pre>
                            </details>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No liveness data available.</p>
                    )}
                  </div>

                  <div
                    className='tab-pane fade'
                    id='similarity'
                    role='tabpanel'
                    aria-labelledby='similarity-tab'
                  >
                    {Array.isArray(logData?.similarity) && logData.similarity.length > 0 ? (
                      logData.similarity.map((entry: any, index: number) => (
                        <div key={index} className="mb-4 border-bottom pb-3">
                          <h6 className="fw-bold">Similarity Check #{index + 1}</h6>
                          <table className="table table-sm table-bordered mb-2">
                            <tbody>
                              <tr>
                                <th style={{width:'40%'}}>Passed</th>
                                <td><span className={entry.passed ? 'text-success fw-bold' : 'text-danger fw-bold'}>{String(entry.passed)}</span></td>
                              </tr>
                              {entry.similarity !== undefined && (
                                <tr><th>Similarity Score</th><td className="fw-bold">{typeof entry.similarity === 'number' ? (entry.similarity * 100).toFixed(1) + '%' : String(entry.similarity)}</td></tr>
                              )}
                              {entry.threshold !== undefined && (
                                <tr><th>Threshold</th><td>{(entry.threshold * 100).toFixed(1) + '%'}</td></tr>
                              )}
                            </tbody>
                          </table>
                          {Array.isArray(entry.attempts) && entry.attempts.length > 0 && (
                            <div className="mb-2">
                              <strong>Attempts:</strong>
                              <table className="table table-sm table-bordered mt-1">
                                <thead><tr><th>#</th><th>Similarity</th><th>Error</th></tr></thead>
                                <tbody>
                                  {entry.attempts.map((a: any, i: number) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{a.similarity !== undefined ? (typeof a.similarity === 'number' ? (a.similarity * 100).toFixed(1) + '%' : String(a.similarity)) : '—'}</td>
                                      <td className="text-danger small">{a.error ?? '—'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No similarity data available.</p>
                    )}
                  </div>

                  <div
                    className='tab-pane fade'
                    id='fints'
                    role='tabpanel'
                    aria-labelledby='fints-tab'
                  >
                    {Array.isArray(logData?.fints) && logData.fints.length > 0 ? (
                      logData.fints.map((entry: any, index: number) => (
                        <div key={index} className="mb-4 border-bottom pb-3">
                          <h6 className="fw-bold">FinTS #{index + 1}</h6>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              {Object.entries(entry)
                                .filter(([k]) => !['_id', 'createdAt', 'updatedAt'].includes(k))
                                .map(([k, v]: [string, any]) => (
                                  <tr key={k}>
                                    <th style={{width:'40%'}}>{k}</th>
                                    <td>{typeof v === 'object' ? <pre className="small mb-0">{JSON.stringify(v, null, 2)}</pre> : String(v ?? '—')}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No FinTS data available.</p>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
        )}
      </div>

      {/* Ako je neuspešno – prikaži sažetak problema */}

      {client && client.status !== 'SUBMITTED' && (
        <div className="alert alert-danger d-flex align-items-start gap-3" role="alert">
          <i className="bi bi-x-octagon-fill fs-4"></i>
          <div>
            <h5 className="alert-heading mb-2">{t('identifizierungNicht')}</h5>
            <p className="mb-1">{t('identificationLog')}</p>
            <ul className="mb-0">
              <strong>{report?.document ?? '—'}</strong>
              <hr></hr>
              <strong>{report?.mrz ?? '—'}</strong>

            </ul>
          </div>
        </div>
      )}

      {/* Slike */}
      <div className="row g-3">
        <div className="col-md-4">
          <div className="card h-100 shadow-sm">
            <div className="card-header">{t('firstPage')}</div>
            <img
              id='documentFront'
              className="card-img-top"
              alt="Document Front"
            />
            <div className="card-body">
              <p className="card-text small text-muted mb-0">{t('checkOne')}</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 shadow-sm">
            <div className="card-header">{t('secondPage')}</div>
            <img id='documentBack'
              className="card-img-top"
              alt="Document Back" />
            <div className="card-body">
              <p className="card-text small text-muted mb-0">{t('checkTwo')}</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 shadow-sm">
            <div className="card-header">Selfie</div>
            <img
              id='face'
              className="card-img-top"
              alt="Selfie" />
            <div className="card-body">
              <p className="card-text small text-muted mb-0">{t('checkThree')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
